<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <transition name="router-animation" enter-active-class="animated slideInUp faster">
      <router-view></router-view>
    </transition> 
    
  </div>
</template>

<script>  
import 'animate.css/animate.css'

export default {
  name: 'app'
}
</script>

<style>
#app {
  font-family: 'Montserrat', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 0px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue